import React, { useEffect, useState } from 'react'
import GoBackHeader from 'components/organisms/GoBackHeader'
import AccordionList from 'components/organisms/Accordion'
import './styles.scss'
import WistiaPlayer from 'components/organisms/WistiaPlayer'
import data from './faqData.json'
import { IAccordionItem } from 'components/organisms/Accordion/model'

const FrequentlyAskedQuestions = (): JSX.Element => {
  const [faqData, setFAQData] = useState<IAccordionItem[]>([])

  useEffect(() => {
    // Load the JSON data when the component mounts
    setFAQData(data) // Store the JSON data in the component's state
  }, [])

  return (
    <React.Fragment>
      <GoBackHeader text="FAQ's"></GoBackHeader>
      <div
        className='ui-faq-page'
        data-testid='frequently-asked-questions-content'
      >
        <h2>Frequently Asked Questions</h2>
        <section className='frequently-asked-overview-text'>
          Watch the Client Portal Overview below or browse our frequently asked
          questions.
        </section>
        <WistiaPlayer videoId='rg953pvux0' wrapper='wistia-player-wrapper' />

        <AccordionList items={faqData} />
      </div>
    </React.Fragment>
  )
}

export default FrequentlyAskedQuestions
